import { useTranslation } from 'react-i18next';

import { InlineTitleEditor } from '@/shared/ui';

import styles from './Kanban.module.css';

interface Props {
  name: string;
  maxLength: number;
  onSave: (name: string) => Promise<unknown>;
  onClose: () => void;
}

/** Inline column rename (behaviour in `InlineTitleEditor`). */
export function ColumnTitleEditor(props: Props) {
  const { t } = useTranslation();
  return (
    <InlineTitleEditor {...props} label={t('columns.name')} className={styles.columnTitleInput} />
  );
}
